import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './style.css';
import { postApiCall } from '../utils/api';
import { CircleSpinnerOverlay } from 'react-spinner-overlay';
import Swal from 'sweetalert2';

const QrScan = () => {
    const location = useLocation();

    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return params.get('phone');
    };

    const providerPhone = getQueryParams();

    const [phone, setPhone] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const phoneRegex = /^[0-9]{10}$/;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!phoneRegex.test(phone)) {
            setErrorMessage('Please enter a valid 10-digit phone number');
        } else {
            setErrorMessage('');

            setLoading(true)

            let res = await postApiCall("user/scanAndEarnAdd", {
                'referred_by_phone': providerPhone,
                'referred_to_phone': phone,
            })

            setLoading(false)

            if (res.error === true) {
                return Swal.fire({
                    title: 'Error',
                    text: res.message,
                    icon: 'error'
                });
            }
            Swal.fire({
                title: 'Successful',
                text: res.message,
                icon: 'success'
            });
            setIsSubmitted(true);
        }
    };

    return (
        <>
            <CircleSpinnerOverlay
                loading={loading}
                overlayColor="rgba(0,153,255,0.2)"
            />
            <div className="qr-container">
                <h3>Scan and Earn</h3>

                {!isSubmitted ? (
                    <form onSubmit={handleSubmit} className="form-container">
                        <label htmlFor="phone" className="form-label">Enter Phone Number:</label>
                        <input
                            type="tel"
                            id="phone"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="Enter 10-digit phone number"
                            className="form-input"
                            required
                        />
                        <button type="submit" className="submit-btn">
                            Submit
                        </button>

                        {/* Display validation error message */}
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                    </form>
                ) : (
                    <div className="success-box">
                        <h2>Success!</h2>
                        <p>Your phone number {phone} has been submitted.</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default QrScan;
